$(document).ready(function() 
{
	$('.showcasesearch').on('click', function() 
	{
		let id = $("#showcasesearch").attr("data-category-id");
		let search =$("#showcasesearch").val();
		$(document).ajaxSend(function() 
		{
			   $("#overlay").fadeIn(300);　
		});  
		$.ajax(
		{
			headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
			url: '/search-invention/' + id,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val(),"search": search},
			dataType: 'json',
			success: function(response)
			{
			 	$('.projectShowcase').html(response.html);
				$(".load-more").css('display','none');
				 
			}
		}).done(function() 
		{
			setTimeout(function(){
			$("#overlay").fadeOut(300);
		},500);
		});       
	});
});

$(document).on("click", ".sliderimages", function()
{
$('#sliderModal').modal('show');
} ); 

//recent inventions

import $ from 'jquery';
window.$ = window.jQuery = $;
/*$(document).ready(function()
{
	$(document).on('click', '.load-more-tags', function(event)
	{
		alert("tags");
		let next_tag_url = $('param[name="next-page-tag"]').val();
		console.log(next_tag_url);
		if (typeof next_tag_url === typeof undefined || next_tag_url == '') 
		{
			return;
		}
		$('.load-more-tags').addClass('dis-none');
		$(document).ajaxSend(function() 
		{
		$	("#overlay").fadeIn(300);　
		});
		let type = "tag";
		$.ajax
		({
			headers: {
						'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
					},
			url: next_tag_url,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val(),"type":type},
			success: function (ajaxResponse) {
			if (ajaxResponse.markup) 
			{
				$('.btags').append(ajaxResponse.markup);
				$('param[name="next-page-tag"]').val(ajaxResponse.next_tag_url);
			} 
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
			},
			complete: function (argument) 
			{
				if ($('param[name="next-page-tag"]').val() == '') 
				{
					$('.load-more-tags').css("display", "none");
				}
			}
			})
			.done(function() {
			setTimeout(function(){
			$("#overlay").fadeOut(300);
			},500);
		});
	});
});


*///load more blogs 
/*$(document).ready(function()
{
	$(document).on('click', '.load-more-home-blogs', function(event)
	{
		let next_vendor_url = $('param[name="next-page-home"]').val();
		console.log(next_vendor_url);
		if (typeof next_vendor_url === typeof undefined || next_vendor_url == '') 
		{
			return;
		}
		$('.load-more-home-blogs').addClass('dis-none');
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$("#overlay").fadeIn(300);      
		let type="homeblog";
		$.ajax({
			headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url: next_vendor_url,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val(),"type":type},
			success: function (ajaxResponse) 
			{
				if (ajaxResponse.markup) 
				{
					$('#post').append(ajaxResponse.markup);
					$('param[name="next-page-home"]').val(ajaxResponse.next_home_url);
				}
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
			},
			complete: function (argument) 
			{
				if ($('param[name="next-page-home"]').val() == '') 
				{
					$('.load-more-home-blogs').css("display", "none");
				}
			}
			})
			.done(function() {
			setTimeout(function(){
			$("#overlay").fadeOut(300);
			},500);
		});
	});
});
*/
//blog author filter
/*$(document).ready(function()
{
	$(document).on('change', '.blogcat', function(event)
	{
		let url = window.location.origin + '/author/' + document.getElementById("bloglistoptions").value;
	    window.location.href = url;
	});
});*/

//blog home page
$(document).ready(function()
{
	$(document).on('click', '.load-more-recent-invention', function(event)
	{
		let next_vendor_url = $('param[name="next_invention_url"]').val();
		console.log(next_vendor_url);
		if (typeof next_vendor_url === typeof undefined || next_vendor_url == '') 
		{
			return;
		}
		$('.load-more-recent-invention').addClass('dis-none');
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			},
			url: next_vendor_url,
			type: 'POST',
			data: {"_token": $("input[name='_token']").val()},
			success: function (ajaxResponse) 
			{
				if (ajaxResponse.markup) 
				{
					$('.post').append(ajaxResponse.markup);
					$('param[name="next_invention_url"]').val(ajaxResponse.next_page_url);
				}
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
			},
			complete: function (argument) 
			{
				if ($('param[name="next_invention_url"]').val() == '') 
				{
					$('.load-more-recent-invention').css("display", "none");
				}
			}
		})
		.done(function() 
		{
			setTimeout(function(){
			$("#overlay").fadeOut(300);
			},500);
		});
	});
});

/*$(document).ready(function () 
{
	$('html,#inventionscroll,#vendorscroll').animate(
	{
	  scrollTop:140
	}, 2000);
});
*/
$(document).on("click", ".portfolio-preview", function()
{
	let i = 0;
	let index_id = $(this).data('pindex');
	let portdata = JSON.parse(localStorage.getItem('allportfolioentries'));
	for (i = 0; i < portdata.length; i++)
	{
		if (portdata[i]['templateTestimonial'] == index_id)
		{
			let img =  '/' + portdata[i]["imagepath"];
			$('.preview-title').html('<b>' + portdata[i]['Author'] + '</b>');
			$('.previewimage').html('<img src="' + img + '" alt="Image" class="img-fluid previewimage" height="465" width="650">');
			$('.preview-description').html(portdata[i]['Description']);
		}
	}
	$('#portfoliopreviewmodal').modal('show');
});
 $(document).on("click", ".hidedata", function()
 {
 	let i = 0;	
 	let j = 0;	
 	let type = $("#previewtype").val();
 	$('#previweinventos').html('');
 	$('#previwetestimonial').html('');
 	let id = $('#invid').val();
 	if (type == 'edit')
 	{
 		$.ajax(
 			  	{
 					headers: 
 					{
 					   'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
 				    },
 				  	url: '/showcase/data/'+ id,
 			 
 				  	type: 'get',
 				  	success: function(response)
 				  	{
 				  		let portfolio = response.portfolio ;
 				  		let testimonialdata = response.testimonials ;
						if(portfolio.length > 0)
						{
							$(".invinventor").show();
							for (i = 0; i < portfolio.length; i++)
							{
								let img =  '/' + portfolio[i]["inventor_by_image"];
								let content = '';
								if (portfolio[i]["inventor_by_image"] != 'NULL')
								{
									content = '<div data-tindex="'+portfolio[i]['invention_id'] + '" data-tid="0" class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv inventor-block content-item inventioninventorblock inventor-1" data-invention-id="0"  data-td="2" ><div class="card-body"><div class="row p-2"><div class="col-md-1"><img src="'+img+'" /></div><div class="col-md-2"><h5 class="p3">' + portfolio[i]['inventor_by'] +' </h4><h4>' + portfolio[i]['inventor_companyName'] + '</h4></div><div class="col-md-9"><h5 class="text-justified">' + portfolio[i]['description'] + ' </h5></div></div></div></div>';
									//content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + portfolio[i]['invention_id'] + '" data-pindex="' + portfolio[i]['invention_id'] + '"id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="'+img+'"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + portfolio[i]['invention_id'] + '" id="folioauthor-' + portfolio[i]['invention_id'] + '">' + portfolio[i]['Author'] +'</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + portfolio[i]['invention_id'] + '" id="foliodesc-' + portfolio[i]['invention_id'] + '">' + portfolio[i]['description'] + '</p></div></a></div>';
								}
								else
								{
									content = '<div data-tindex="'+portfolio[i]['invention_id'] + '" data-tid="0" class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv inventor-block content-item inventioninventorblock inventor-1" data-invention-id="0"  data-td="2" ><div class="card-body"><div class="row p-2"><div class="col-md-1"><img src="/images/avtar.JPG" /></div><div class="col-md-2"><h5 class="p3">' + portfolio[i]['inventor_by'] +' </h4><h4>' + portfolio[i]['inventor_companyName'] + '</h4></div><div class="col-md-9"><h5 class="text-justified">' + portfolio[i]['description'] + ' </h5></div></div></div></div>';
									//content = '<div class="col-md-3 portfolio-preview portfolio-0" data-pid="0" data-pindex="' + portfolio[i]['invention_id'] + '" id="portfolio-0" id="rd"><div class="d-block d-md-flex listing vertical" ><a href="javascript:void(0)" onclick=""class="img d-block"><img style="width:315px;height:133px"   src="{{url("images/portfolio1.jpg")}}"  class="img-fluid"></a><div class="lh-content"><h3><a href="javascript:void(0)" class="pauthor-' + portfolio[i]['invention_id'] + '" id="folioauthor-' + portfolio[i]['invention_id'] + '">' + portfolio[i]['Author'] + '</a></h3><p  class="pdesc-' + portfolio[i]['invention_id'] + '" id="foliodesc-' + portfolio[i]['invention_id'] + '">' + portfolio[i]['description'] + '</p></div></div></div>';
								}
								$('#previweinventos').append(content);
								$('#previweinventos').show();
								$("#inventorparentrow").hide();
							}
						}
						else
						{
							$(".invinventor").hide();
						}
						if (testimonialdata.length > 0)
						{
							$(".invtestimonial").show();
							let content = '<div class="testimonialshow1 slick-slider1">';
							for (i = 0; i < testimonialdata.length; i++)
							{
								let img =  '/' + testimonialdata[i]["testimonial_by_image"];
								content += '<div class="col-md-3 mb-4 card box-sha p-4 slick-slide totaldiv testimonial-block content-item 1" data-tindex="1" data-tid="0" data-invention-id="0"  data-td="2" ><div class="card-body">';
								content += '<p class="card-text text-secondary text-justified fst-italic testimonialstxt text-dark mb-5 desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">'+ testimonialdata[i]['testimonial'] + '</p>';
								if (testimonialdata[i]["testimonial_by_image"] != undefined)
								{
									content+= '<div class="d-flex align-items-center"><div class="imgfitshow"><img src="' + img + '" class="img" id="img-0"/></div>';
								}
								else
								{
									content+= '<div class="d-flex align-items-center"><div class="imgfitshow"><img src="/images/avtar.JPG" class="img" id="img-0"/></div>';
								}
								content += '<div class="mx-2"><div class="d-flex startRating"><strong class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">' + testimonialdata[i]['testimonial_companyName'] + '</strong></div><h5 class="py-2 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testimonialdata[i]['testimonial_by'] + '</h5>	</div></div></div></div>';
								$('#previwetestimonial').append(content);
								$(".testimonialslider1").slick({
								        dots: true,
								        infinite: true,
								        slidesToShow: 1,
								        slidesToScroll: 1,
								        arrows: true
								      });


								$(".testimonialshow1").slick({
								        dots: true,
								        rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
								        infinite: true,
								        slidesToShow: 3,
								        slidesToScroll: 3,
								        arrows: false,
								        mobileFirst: true,
								        responsive: [
								    {
								      breakpoint: 1024,
								      settings: {
								        rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
								        slidesToShow: 3,
								        slidesToScroll: 3,
								        infinite: true,
								        dots: true,
								        arrows: false
								      }
								    },
								    {
								      breakpoint: 800,
								      settings: {
								        rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
								        slidesToShow: 2,
								        slidesToScroll: 2,
								        infinite: true,
								        dots: true,
								        arrows: false
								      }
								    },
								    {
								     rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
								      breakpoint: 600,
								      settings: {
								        slidesToShow: 2,
								        slidesToScroll: 2,
								        dots: true,
								        arrows: false

								      }
								    },
								    {
								      breakpoint: 320,
								      settings: {
								        mobileFirst: true,
								        arrows: true,
								        rows: 1,
								        slidesToShow: 1,
								        slidesToScroll: 1,
								        dots:false
								        }
								    }
								  ]
								});
								$(window).resize(function(){
								$('.testimonialslider1,.testimonialshow1').slick('setPosition');
								});

							}
						}
						else
						{
							$(".invtestimonial").hide();
						}

 				  	}
 				}
 			);

 	}
 	let portdata = JSON.parse(localStorage.getItem('AllInventors'));
 	if (portdata != null)
 	{
 		$(".invinventor").show();
 		for (i = 0; i < portdata.length; i++)
 		{
 			let img =  '/' + portdata[i]["fileToUpload"];
 			let content = '';
 			if (portdata[i]["fileToUpload"] != undefined && portdata[i]["fileToUpload"] != null)
 			{
 				content = '<div data-tindex="'+portdata[i]['templateTestimonial'] + '" data-tid="0" class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv inventor-block content-item inventioninventorblock inventor-1" data-invention-id="0"  data-td="2" ><div class="card-body"><div class="row p-2"><div class="col-md-1"><img src="'+img+'" /></div><div class="col-md-2"><h5 class="p3">' + portdata[i]['Author'] +' </h4><h4>' + portdata[i]['companyName'] + '</h4></div><div class="col-md-9"><h5 class="text-justified">' + portdata[i]['Description'] + ' </h5></div></div></div></div>';
 				//content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + portdata[i]['templateTestimonial'] + '" data-pindex="' + portdata[i]['templateTestimonial'] + '"id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="'+img+'"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + portdata[i]['templateTestimonial'] + '" id="folioauthor-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Author'] +'</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + portdata[i]['templateTestimonial'] + '" id="foliodesc-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Description'] + '</p></div></a></div>';
 			}
 			else
 			{
 				content = '<div data-tindex="'+portdata[i]['templateTestimonial'] + '" data-tid="0" class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv inventor-block content-item inventioninventorblock inventor-1" data-invention-id="0"  data-td="2" ><div class="card-body"><div class="row p-2"><div class="col-md-1"><img src="/images/avtar.JPG" /></div><div class="col-md-2"><h5 class="p3">' + portdata[i]['Author'] +' </h4><h4>' + portdata[i]['companyName'] + '</h4></div><div class="col-md-9"><h5 class="text-justified">' + portdata[i]['Description'] + ' </h5></div></div></div></div>';
 				//content = '<div class="col-md-3 portfolio-preview portfolio-0" data-pid="0" data-pindex="' + portdata[i]['templateTestimonial'] + '" id="portfolio-0" id="rd"><div class="d-block d-md-flex listing vertical" ><a href="javascript:void(0)" onclick=""class="img d-block"><img style="width:315px;height:133px"   src="{{url("images/portfolio1.jpg")}}"  class="img-fluid"></a><div class="lh-content"><h3><a href="javascript:void(0)" class="pauthor-' + portdata[i]['templateTestimonial'] + '" id="folioauthor-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Author'] + '</a></h3><p  class="pdesc-' + portdata[i]['templateTestimonial'] + '" id="foliodesc-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Description'] + '</p></div></div></div>';
 			}
 			$('#previweinventos').append(content);
 			$('#previweinventos').show();
 			$("#inventorparentrow").hide();
 		}
 	}
 	else
 	{
 		$(".invinventor").hide();
 	}
 	let testimonialdata = JSON.parse(localStorage.getItem('inventionEntries'));
 	if (testimonialdata != null)
 	{
 		$(".invtestimonial").show();
 		let content = '<div class="testimonialshow1 slick-slider1">';
 		for (i = 0; i < testimonialdata.length; i++)
 		{
 			let img =  '/' + testimonialdata[i]["fileToUpload"];
 			content += '<div class="col-md-3 mb-4 card box-sha p-4 slick-slide totaldiv testimonial-block content-item 1" data-tindex="1" data-tid="0" data-invention-id="0"  data-td="2" ><div class="card-body">';
 			content += '<p class="card-text text-secondary text-justified fst-italic testimonialstxt text-dark mb-5 desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">'+ testimonialdata[i]['Description'] + '</p>';
 			if (testimonialdata[i]["fileToUpload"] != undefined)
 			{
 				content+= '<div class="d-flex align-items-center"><div class="imgfitshow"><img src="' + img + '" class="img" id="img-0"/></div>';
 			}
 			else
 			{
 				content+= '<div class="d-flex align-items-center"><div class="imgfitshow"><img src="/images/avtar.JPG" class="img" id="img-0"/></div>';
 			}
 			content += '<div class="mx-2"><div class="d-flex startRating"><strong class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">' + testimonialdata[i]['companyName'] + '</strong></div><h5 class="py-2 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testimonialdata[i]['Author'] + '</h5>	</div></div></div></div>';
 			$('#previwetestimonial').append(content);
 			$(".testimonialslider1").slick({
 			        dots: true,
 			        infinite: true,
 			        slidesToShow: 1,
 			        slidesToScroll: 1,
 			        arrows: true
 			      });


 			$(".testimonialshow1").slick({
 			        dots: true,
 			        rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
 			        infinite: true,
 			        slidesToShow: 3,
 			        slidesToScroll: 3,
 			        arrows: false,
 			        mobileFirst: true,
 			        responsive: [
 			    {
 			      breakpoint: 1024,
 			      settings: {
 			        rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
 			        slidesToShow: 3,
 			        slidesToScroll: 3,
 			        infinite: true,
 			        dots: true,
 			        arrows: false
 			      }
 			    },
 			    {
 			      breakpoint: 800,
 			      settings: {
 			        rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
 			        slidesToShow: 2,
 			        slidesToScroll: 2,
 			        infinite: true,
 			        dots: true,
 			        arrows: false
 			      }
 			    },
 			    {
 			     rows: ($(".testimonialshow1 .slick-slide1").length >4) ? 2 : 1,
 			      breakpoint: 600,
 			      settings: {
 			        slidesToShow: 2,
 			        slidesToScroll: 2,
 			        dots: true,
 			        arrows: false

 			      }
 			    },
 			    {
 			      breakpoint: 320,
 			      settings: {
 			        mobileFirst: true,
 			        arrows: true,
 			        rows: 1,
 			        slidesToShow: 1,
 			        slidesToScroll: 1,
 			        dots:false
 			        }
 			    }
 			  ]
 			});
 			$(window).resize(function(){
 			$('.testimonialslider1,.testimonialshow1').slick('setPosition');
 			});

 		}
 	}
 	else
 	{
 		$(".invtestimonial").hide();
 	}
 	let downloaddata = JSON.parse(localStorage.getItem('Alldownloadfiles'));
 	//alert(downloaddata);
 	if (downloaddata != null)
 	{
 		for (i = 0; i < downloaddata.length; i++)
 		{}
 	}
 	else
 	{
 		$(".cardboxdownload").hide();
 	}
 	$("#testimonialshow").hide();
 	$("#previwetestimonial").show();
 	$('.invention-preview').html('Edit/Create');
 	$('.invention-preview').addClass('create-edit');
 	$('.invention-preview').removeClass('hidedata');
 	let test = localStorage.getItem('inventionEntries');
 	let cat = localStorage.getItem('inventionCategory');
 	let Desc = localStorage.getItem('Description');
 	let invstorage = localStorage.getItem('AllInventors');
 	let download = localStorage.getItem('Alldownloadfiles');
 	/*if(cat == null)
 	{
 		$(".category-block").css('display','none');
 	}*/
 	if (download == null)
 	{
 		$(".invdow").css('display', 'none');
 	}
 	if (invstorage == null)
 	{
 		$(".invinventor").css('display', 'none');
 	}
 	if (test == null)
 	{
 		$(".invtestimonial").css('display', 'none');
 	}
 	if (Desc == null)
 	{
 		$(".invdesc").css('display', 'none');
 	}
 	$(".testimonial-block").removeClass('inventontestimonialblock');
 	$(".category-block").removeClass('categorychange');
 	$(".inventor-block ").removeClass('inventioninventorblock');
 	$("#title").removeClass('cjs-allow-change');
 	$("#title").removeClass('cjs-change-title');
 	$("#desc").removeClass('cjs-change-title');
 	$(".descdata").html('Description');
 	$(".aboutinventordata").html('About Inventors');
 	$(".testimonialheadata").html('Testimonials');
 	$(".downloadheadata").html('Downloads');
 	$(".del").hide();
 	$(".remo").hide();
 	$(".uploadarea").hide();
 	$(".testimonialaddbtn").hide();
 	$(".inventoraddbtn").hide();
 	$(".uploadarea").hide();
 	$(".slider-block").hide('sliderimages');
 	$(".slider-block").css('display:none');
 });
 $(document).on("click", ".create-edit", function()
 {
 	$(".descdata").html('Click below to add description about your product.');
 	$(".aboutinventordata").html('Click on below card to enter details about inventors');
 	$(".testimonialheadata").html('Click below cards to add Testimonials');
 	$(".downloadheadata").html('Click below to add documents for users to download');
 	$("#title").addClass('cjs-change-title');
 	$('#previweinventos').hide();
 	$("#inventorparentrow").show();
 	$("#previwetestimonial").css('display', 'none');
 	$("#testimonialshow").css('display', 'block');
 	$(".category-block").css('display', 'block');
 	$(".invdow").css('display', 'block');
 	$(".invinventor").css('display', 'block');
 	$(".invtestimonial").css('display', 'block');
 	$(".invdesc").css('display', 'block');
 	$('.invention-preview').html('Preview');
 	$('.invention-preview').removeClass('create-edit');
 	$('.invention-preview').addClass('hidedata');
 	$(".category-block").addClass('categorychange');
 	$(".inventor-block ").addClass('inventioninventorblock');
 	$(".testimonial-block").addClass('inventontestimonialblock');
 	$("#title").addClass('cjs-allow-change ');
 	$("#desc").addClass('cjs-allow-change ');
 	$("#desc").addClass('cjs-change-title');
 	$(".del").show();
 	$(".remo").show();
 	$(".uploadarea").show();
 	$(".testimonialaddbtn").show();
 	$(".inventoraddbtn").show();
 	$(".slider-block").addClass('sliderimages');
 	$(".slider-block").show('sliderimages');
 	$(".uploadarea").show();

 });